import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getVetoStatsForTeamBySeason } from '../../services/MatchService';
import Loading from '../../components/Loading';
import MapCardsView from './StatsTable/MapCardsView';
import MapSectionsView from './StatsTable/MapSectionsView';
import { MapStats } from '../../models/MapStats';
import ViewListIcon from '@mui/icons-material/ViewList';
import GridViewIcon from '@mui/icons-material/GridView';

type ViewMode = 'cards' | 'list';

/** `teamId` is the squad's canonical id; it defaults to the URL's. */
const TeamMapStats = ({ season, teamId: squadId }: { season: number; teamId?: string }) => {
    const params = useParams<{ teamId: string }>();
    const teamId = squadId ?? params.teamId;
    const [mapStats, setMapStats] = useState<MapStats[]>([]);
    const [loading, setLoading] = useState(true);
    const [viewMode, setViewMode] = useState<ViewMode>('cards');

    useEffect(() => {
        if (!teamId) return;

        const fetchMapStats = async () => {
            setLoading(true);
            try {
                const stats = await getVetoStatsForTeamBySeason(teamId, season.toString());
                setMapStats(stats);
            } catch (err) {
                console.error(err);
            }
            setLoading(false);
        };

        fetchMapStats();
    }, [teamId, season]);

    const toggleView = () => setViewMode(v => v === 'cards' ? 'list' : 'cards');

    return (
        <div className="container">
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '12px' }}>
                <button
                    onClick={toggleView}
                    title={viewMode === 'cards' ? 'Switch to list view' : 'Switch to card view'}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '34px',
                        height: '34px',
                        borderRadius: '6px',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        background: 'rgba(255, 255, 255, 0.04)',
                        color: 'rgba(255, 255, 255, 0.5)',
                        cursor: 'pointer',
                        transition: 'background-color 0.2s ease, border-color 0.2s ease',
                    }}
                >
                    {viewMode === 'cards'
                        ? <ViewListIcon style={{ fontSize: 18 }} />
                        : <GridViewIcon style={{ fontSize: 18 }} />
                    }
                </button>
            </div>

            {loading ? (
                <Loading />
            ) : viewMode === 'cards' ? (
                <MapCardsView mapStats={mapStats} />
            ) : (
                <MapSectionsView mapStats={mapStats} />
            )}
        </div>
    );
};

export default TeamMapStats;
